import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useCart } from '@/hooks/useCart';
import { useDatabaseFavorites } from '@/hooks/useDatabaseFavorites';

// Inline SVG Icons
const HeartIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l11 11Z" />
  </svg>;
const UserIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>;
const LogOutIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16,17 21,12 16,7" />
    <path d="m21 12-8 0" />
  </svg>;
export const HeaderAuth = () => {
  const {
    favorites
  } = useDatabaseFavorites();
  const [authInitialized, setAuthInitialized] = useState(false);
  const {
    user,
    isAdmin,
    isSuperAdmin,
    signOut,
    loading
  } = useAuth();

  // Wait for auth to be properly initialized
  useEffect(() => {
    if (!loading) {
      // Add a small delay to ensure role states are synchronized
      const timer = setTimeout(() => {
        setAuthInitialized(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loading, isAdmin, isSuperAdmin]);
  const handleSignOut = async () => {
    try {
      setAuthInitialized(false); // Reset auth state
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  const showAdminLink = authInitialized && (isAdmin || isSuperAdmin);
  return <>
      {/* Desktop Auth Section */}
      <div className="hidden md:flex items-center space-x-2 flex-shrink-0">
        <Link to="/favorites" className="p-2 hover:text-springbok-500 transition-colors relative">
          <HeartIcon />
          {favorites.length > 0 && <span className="absolute -top-1 -right-1 bg-springbok-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
              {favorites.length}
            </span>}
        </Link>

        {user ? <div className="flex items-center space-x-2">
            <Link to="/account" className="p-2 hover:text-springbok-500 transition-colors relative">
              <UserIcon />
              <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white" />
            </Link>
            <span className="text-sm text-[#07f528]">Hello, {user.email?.split('@')[0]}</span>
            <Button 
              variant="secondary" 
              size="sm" 
              onClick={handleSignOut} 
              className="ml-2"
              data-gradient="gold"
            >
              <LogOutIcon />
              <span className="ml-1">Logout</span>
            </Button>
          </div> : <>
            <Link to="/login" className="p-2 hover:text-springbok-500 transition-colors relative">
              <UserIcon />
            </Link>
            <div className="ml-2">
              <Link to="/login">
                <Button 
                  variant="secondary" 
                  size="sm" 
                  className="mr-2"
                  data-gradient="gold"
                >
                  Login
                </Button>
              </Link>
              <Link to="/register">
                <Button 
                  size="sm"
                  data-gradient="green"
                >
                  Register
                </Button>
              </Link>
            </div>
          </>}
      </div>

      {/* Top Banner Admin Link */}
      {showAdminLink && <Link to="/admin" className="hover:text-gold-400 transition-colors">
          Admin
        </Link>}
    </>;
};